import CryptoJS from 'crypto-js';

const secretKey = process.env.REACT_APP_COOKIE_SECRET || "9CzRdmuALsG2vN5Rb8fJi1p3hQO7wEzU";

// Function to encrypt a string
export const encrypt = (text) => {
    // console.log("Encryption key:", secretKey);
    return CryptoJS.AES.encrypt(text, secretKey).toString();
}

// Function to decrypt an encrypted string
export const decrypt = (encryptedText) => {
    // console.log("encryptedText:", encryptedText);
    const bytes = CryptoJS.AES.decrypt(encryptedText, secretKey);
    return bytes.toString(CryptoJS.enc.Utf8);
}
